enum EFeatureFlags {
  POWER_BI_DASHBOARD = 'POWER_BI_DASHBOARD',
  BLOCK_USER_GALLERY = 'BLOCK_USER_GALLERY',
  SINGLE_QRCODE = 'SINGLE_QRCODE',
  NA_AS_DEFAULT_ANSWER = 'NA_AS_DEFAULT_ANSWER',
  NOTIFICATIONS_WEBHOOKS = 'NOTIFICATIONS_WEBHOOKS',
  SCHEDULED_SERVICES = 'SCHEDULED_SERVICES',
  BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING = 'BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING',
  BLOCK_QR_CODE_READING_WITHOUT_LOGIN = 'BLOCK_QR_CODE_READING_WITHOUT_LOGIN',
  FINISHED_ACTIONS_ADMINS_NOTIFICATION = 'FINISHED_ACTIONS_ADMINS_NOTIFICATION',
  BLOCK_RETROACTIVE_SERVICES_FOR_ANALYSTS_AND_CONTRACTORS = 'BLOCK_RETROACTIVE_SERVICES_FOR_ANALYSTS_AND_CONTRACTORS',
  BLOCK_EQUIPMENT_CREATION_IN_SITES_WITHOUT_ACCESS = 'BLOCK_EQUIPMENT_CREATION_IN_SITES_WITHOUT_ACCESS',
}

export default EFeatureFlags;
